var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio-group',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}},_vm._l((_vm.dataSource),function(item){return _c('el-radio',{key:item.dictCode,attrs:{"label":item[_vm.valueKey]}},[_vm._v(_vm._s(item[_vm.labelKey]))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }